/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-self-assign */
import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { withTranslation } from 'react-i18next';
import {
    Paper,
    Typography,
    Button,
    Grid,
    Box,
    useMediaQuery,
    Container,
    CircularProgress,
    Hidden,
    DialogContent,
    Dialog,
    DialogTitle,
    DialogActions,
    Snackbar,
    Stack,
} from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import { withRouter, Link as RouterLink } from 'react-router-dom';
import { ChevronLeft, DeleteOutline, InfoOutlined, PriorityHigh } from '@mui/icons-material';
import { FormProvider, useFieldArray, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Alert } from '@mui/lab';
import moment from 'moment-timezone';
import { cloneDeep } from 'lodash';
import { useDebouncedCallback } from 'use-debounce';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { WithContexts } from '../../contexts/withContexts';
import { getTimesheetById, saveTimesheet } from '../../services/TimeAndPayService';
import { getHolidays } from '../../services/MetaDataService';
import ToolTipComponent from '../../components/GlobalComponents/ToolTipComponent';
import TimesheetEntry from '../../components/ContentComponents/Timesheets/TimesheetEntry';
import MileageEntry from '../../components/ContentComponents/Timesheets/MileageEntry';
import useQuery from '../../utils/useQuery';
import { TimesheetStatusEnumApi } from '../../components/ContentComponents/Timesheets/Status.enum';
import RateDisplayNameEnum from '../../components/ContentComponents/Timesheets/RateDisplayName.enum';
import StatusErrorDialog from '../../Shared/Components/StatusErrorDialog';
import { AdminAuthContext } from '../../Admin/Contexts/AdminAuthContext';
import TimesheetHistory from '../../Admin/Components/TimesheetHistory';
import { getConfigurationSetting } from '../../services/AppConfigService';
import { formatErrorMessage } from '../../Shared/Utils/ErrorMessage';
import TimesheetStyles from './TimesheetStyles';
import { getTimesheetCommentWarnings, addTimesheetCommentWarning } from '../../utils/helpers';
import TimesheetAttachments from '../../components/ContentComponents/Timesheets/Attachments';
import { COLORS } from '../../utils/Application_Constants';
import PaperTimesheetBadge from '../../Shared/Components/PaperTimesheetBadge';
import { config as TimesheetReviewConfig } from '../../Admin/Configurations/TimesheetReviewConfig';

function Timesheet(props) {
    const { t, UserContext, setRefreshNotifications } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'), {
        defaultMatches: true,
    });
    const { ltoeWebTimesheetEnablePaperTimesheetUpload } = useFlags();
    const [dateLookup, setDateLookup] = useState([]);
    const [timesheet, setTimesheet] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [cancelModalOpen, setCancelModalOpen] = useState(false);
    const [wordList, setWordList] = useState(null);
    const [commentWarningAlertModalOpen, setCommentWarningAlertModalOpen] = useState(false);
    const [emptyTimesheetModalOpen, setEmptyTimesheetModalOpen] = useState(false);

    const [officialLTHolidays, setOfficialLTHolidays] = useState(null);
    const [holidayPromptCheckedDates, setHolidayPromptCheckedDates] = useState([]);
    const [openHolidayPrompt, setOpenHolidayPrompt] = useState(false);
    const [holidayPromptProperties, setHolidayPromptProperties] = useState(null);
    const [doRerunHolidayPrompt, setDoRerunHolidayPrompt] = useState(false);
    const [hasSelectedYesOnHolidayPrompt, setHasSelectedYesOnHolidayPrompt] = useState(false);

    const [isMileageExpected, setIsMileageExpected] = useState(false);
    const { id } = useParams();
    const query = useQuery();
    const weekEnding = query.get('weekEnding');
    const clinicianId = query.get('clinicianId');
    const forceEditMode = query.get('edit') === 'true';
    const externalId = UserContext && UserContext.externalId ? UserContext.externalId : clinicianId;
    const history = useHistory();
    const [recallWarningDialogOpen, setRecallWarningDialogOpen] = useState(false);
    const [recallErrorDialogOpen, setRecallErrorDialogOpen] = useState(false);
    const [recallErrorType, setRecallErrorType] = useState();
    const [clearDialogOpen, setClearDialogOpen] = useState(false);
    const [cleared, setCleared] = useState(false);
    const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isPaidApproved, setIsPaidApproved] = useState(false);
    const [readOnlyLocations, setReadOnlyLocations] = useState([]);
    const [error, setError] = useState();
    const [errorLoadingTimesheet, setErrorLoadingTimesheet] = useState();
    const commentWarning = useRef(false);
    const commentWordList = useRef([]);
    const [isSave, setIsSave] = useState(false);
    const formRef = useRef(null);
    const adminAuth = useContext(AdminAuthContext);
    const [historyEnabled, setHistoryEnabled] = useState(false);
    const [totalTimesheetHours, setTotalTimesheetHours] = useState(0);
    const [isShowWarning, setIsShowWarning] = useState(false);

    const getStylesheet = () => {
        const styles = TimesheetStyles;
        const useStyles = makeStyles(styles);
        return useStyles();
    };

    const classes = getStylesheet();

    const settingDidNotWork = useRef(false);

    const historyEnabledStatuses = [
        TimesheetStatusEnumApi.DidNotWork,
        TimesheetStatusEnumApi.NotStarted,
        TimesheetStatusEnumApi.PendingSubmission,
        TimesheetStatusEnumApi.Rejected,
    ];
    const readOnlyStatuses = [
        TimesheetStatusEnumApi.Submitted,
        TimesheetStatusEnumApi.Approved,
        TimesheetStatusEnumApi.Paid,
    ];
    const formHasRejectedTimesheet = !!timesheet?.timesheetReviews?.filter(
        (timesheetReview) => timesheetReview?.status === TimesheetStatusEnumApi.Rejected
    )?.length;
    const isAdminApp = process.env.REACT_APP_TYPE === 'Admin';

    const methods = useForm({ defaultValues: {} });

    const {
        formState: { isDirty },
        watch,
    } = methods;

    const {
        fields: timesheetEntries,
        append: timesheetAppend,
        insert: timesheetInsert,
        remove: timesheetRemove,
    } = useFieldArray({
        control: methods.control,
        name: 'timesheetEntries',
        keyName: 'timesheetEntryId',
    });
    const {
        fields: mileageEntries,
        append: mileageAppend,
        remove: mileageRemove,
    } = useFieldArray({
        control: methods.control,
        name: 'mileageEntries',
        keyName: 'mileageEntryId',
    });

    const useDynamicWatch = (dynamicFieldNames) => {
        const watchedValues = useMemo(() => watch(dynamicFieldNames), [dynamicFieldNames]);
        return watchedValues;
    };

    const dynamicTimesheetCommentFieldNames = useMemo(
        () =>
            timesheetEntries.reduce((fieldNames, field, currentIndex) => {
                const fieldName = `timesheetEntries[${currentIndex}].comment`;
                return [...fieldNames, fieldName];
            }, []),
        [timesheetEntries]
    );

    const dynamicMileageCommentFieldNames = useMemo(
        () =>
            mileageEntries.reduce((fieldNames, field, currentIndex) => {
                const fieldName = `mileageEntries[${currentIndex}].comment`;
                return [...fieldNames, fieldName];
            }, []),
        [mileageEntries]
    );

    const watchedValues = useDynamicWatch(
        dynamicTimesheetCommentFieldNames.concat(dynamicMileageCommentFieldNames)
    );

    function containsAny(str, substrings) {
        const rtnStrings = [];
        for (let i = 0; i !== substrings.length; i++) {
            const substring = substrings[i];
            const re = new RegExp(String.raw`\b${substring}\b`, 'gi');
            if (str.search(re) >= 0) {
                rtnStrings.push(substring);
            }
        }
        return rtnStrings;
    }

    const isCallBackEntry = (timesheetEntry) => !!timesheetEntry.relatedEntryId;

    const detectCommentWarnings = async () => {
        if (commentWarning.current) {
            const contextwarningtimesheet = getTimesheetCommentWarnings();

            if (!contextwarningtimesheet.includes(id)) {
                addTimesheetCommentWarning(id);
            } else {
                return false;
            }
            setIsShowWarning(true);
            setCommentWarningAlertModalOpen(true);
            return true;
        }
        return false;
    };

    const validateHoursOverlap = ({ timesheetEntries: receivedTimesheetEntries }) => {
        let hasOverlap = false;

        const checkOverlap = (entryA, entryB, indexA, indexB) => {
            const {
                startTime: startTimeA,
                endTime: endTimeA,
                transactionDate: transactionDateA,
                rateTypeId: rateTypeIdA,
            } = entryA;

            const {
                startTime: startTimeB,
                endTime: endTimeB,
                transactionDate: transactionDateB,
                rateTypeId: rateTypeIdB,
            } = entryB;

            if (startTimeA === '' || endTimeA === '' || startTimeB === '' || endTimeB === '')
                return;

            const rateTypeA = timesheet.booking.availableRates.find((r) => r.id === rateTypeIdA);
            const rateTypeB = timesheet.booking.availableRates.find((r) => r.id === rateTypeIdB);

            const startDateA = moment.utc(transactionDateA).add(moment.duration(startTimeA));
            const endDateA = moment.utc(transactionDateA).add(moment.duration(endTimeA));
            const startDateB = moment.utc(transactionDateB).add(moment.duration(startTimeB));
            const endDateB = moment.utc(transactionDateB).add(moment.duration(endTimeB));

            const isMultiDayA = endDateA.isSameOrBefore(startDateA);
            const isMultiDayB = endDateB.isSameOrBefore(startDateB);

            if (isMultiDayA) endDateA.add(1, 'day');
            if (isMultiDayB) endDateB.add(1, 'day');

            const overlaps =
                startDateA.isBetween(startDateB, endDateB) ||
                endDateA.isBetween(startDateB, endDateB) ||
                startDateB.isBetween(startDateA, endDateA) ||
                endDateB.isBetween(startDateA, endDateA) ||
                startDateA.isSame(startDateB) ||
                endDateA.isSame(endDateB);

            if (overlaps) {
                if (rateTypeA.category === 'Hours' && rateTypeB.category === 'Hours') {
                    hasOverlap = true;
                    ['startTime', 'endTime'].forEach((timeField) => {
                        ['A', 'B'].forEach((suffix) => {
                            const entryIndex = suffix === 'A' ? indexA : indexB;
                            const fieldName = timeField === 'startTime' ? 'Start time' : 'End time';
                            methods.setError(`timesheetEntries[${entryIndex}].${timeField}`, {
                                type: 'manual',
                                message: `${fieldName} can't overlap`,
                            });
                        });
                    });
                }
            }
        };

        for (let indexA = 0; indexA < receivedTimesheetEntries.length; indexA++) {
            for (let indexB = indexA + 1; indexB < receivedTimesheetEntries.length; indexB++) {
                checkOverlap(
                    receivedTimesheetEntries[indexA],
                    receivedTimesheetEntries[indexB],
                    indexA,
                    indexB
                );
            }
        }

        return hasOverlap;
    };

    const convertTimeToUTC = (timeInput, dateInput, timeZone) => {
        const date = moment(dateInput);
        const time = moment(timeInput, 'HH:mm a');

        const dateAndTime = moment
            .tz(timeZone)
            .month(date.month())
            .date(date.date())
            .year(date.year())
            .hour(time.hour())
            .second(time.second())
            .minute(time.minutes());
        return moment.utc(dateAndTime).format();
    };

    const formatTimesheetEntryBreaks = (entry, transactionDate, locationId) => {
        if (!entry.timesheetBreaks) return [];

        const timeZoneTransaction =
            timesheet?.booking?.locations?.find((location) => location.id === locationId)
                ?.timeZone || moment.tz.guess();

        const timesheetBreaks = cloneDeep(entry.timesheetBreaks);

        return timesheetBreaks
            .filter((timesheetBreak) => timesheetBreak.startTime && timesheetBreak.endTime)
            .map((tsBreak) => {
                const timesheetBreak = tsBreak;
                timesheetBreak.startTime = convertTimeToUTC(
                    timesheetBreak.startTime,
                    transactionDate,
                    timeZoneTransaction
                );
                timesheetBreak.endTime = convertTimeToUTC(
                    timesheetBreak.endTime,
                    transactionDate,
                    timeZoneTransaction
                );

                if (moment(timesheetBreak.startTime).isBefore(entry.startTime)) {
                    timesheetBreak.startTime = moment(timesheetBreak.startTime)
                        .add(1, 'day')
                        .utc()
                        .format();
                    timesheetBreak.endTime = moment(timesheetBreak.endTime)
                        .add(1, 'day')
                        .utc()
                        .format();
                }

                if (moment(timesheetBreak.endTime).isBefore(timesheetBreak.startTime)) {
                    timesheetBreak.endTime = moment(timesheetBreak.endTime)
                        .add(1, 'day')
                        .utc()
                        .format();
                }

                return timesheetBreak;
            });
    };

    const formatTimesheetEntries = (entries) => {
        if (entries) {
            return entries
                .filter((entry) => entry.transactionDate)
                .map((existingEntry) => {
                    const entry = existingEntry;
                    entry.id = entry.id;
                    const timeZoneTransaction =
                        timesheet?.booking?.locations?.find(
                            (location) => location.id === entry.locationId
                        )?.timeZone || moment.tz.guess();
                    const transactionDate = moment.tz(entry.transactionDate, 'Greenwich');
                    entry.transactionDate = transactionDate.format();
                    entry.startTime =
                        !entry.startTime || entry.startTime === ''
                            ? null
                            : convertTimeToUTC(
                                  entry.startTime,
                                  transactionDate,
                                  timeZoneTransaction
                              );
                    entry.endTime =
                        !entry.endTime || entry.endTime === ''
                            ? null
                            : convertTimeToUTC(entry.endTime, transactionDate, timeZoneTransaction);
                    entry.locationId = entry.locationId === '' ? null : entry.locationId;
                    entry.rateTypeId = entry.rateTypeId === '' ? null : entry.rateTypeId;
                    entry.relatedEntryId =
                        entry.relatedEntryId === '' ? null : entry.relatedEntryId;
                    entry.units = entry.units === '' ? null : entry.units.toString();
                    entry.comment = entry.comment === '' ? null : entry.comment;

                    if (entry.startTime && entry.endTime) {
                        const startTime = moment(entry.startTime).tz(timeZoneTransaction);
                        const endTime = moment(entry.endTime).tz(timeZoneTransaction);
                        const isMultiDay = endTime.isSameOrBefore(startTime);
                        if (isMultiDay) {
                            endTime.add(1, 'day');
                            entry.endTime = endTime.utc().format();
                        }
                    }

                    entry.timesheetBreaks = formatTimesheetEntryBreaks(
                        entry,
                        transactionDate,
                        entry.locationId
                    );

                    return entry;
                });
        }
        return [];
    };

    const setBreakError = (entryIndex, index, fieldName, errorMessage) => {
        const fullFieldName = `timesheetEntries[${entryIndex}].timesheetBreaks[${index}].${fieldName}`;

        methods.setError(fullFieldName, {
            type: 'manual',
            message: errorMessage,
        });
    };

    const getValidBreakRateTypeIds = () => {
        const validBreakRateTypeIds = [];

        const validBreakRateTypeNames = [
            RateDisplayNameEnum.Regular,
            RateDisplayNameEnum.RegularOnsite,
            RateDisplayNameEnum.RegularTele,
            RateDisplayNameEnum.DayShift,
            RateDisplayNameEnum.DayShiftOnsite,
            RateDisplayNameEnum.DayShiftTele,
            RateDisplayNameEnum.NightShift,
            RateDisplayNameEnum.NightShiftOnsite,
            RateDisplayNameEnum.NightShiftTele,
            RateDisplayNameEnum.Orientation,
            RateDisplayNameEnum.OrientationOnsite,
            RateDisplayNameEnum.OrientationTele,
        ];

        validBreakRateTypeNames.forEach((rateTypeName) => {
            const rate = timesheet.booking.availableRates.find(
                (availableRate) => availableRate.displayName === rateTypeName
            );

            if (rate?.id) {
                validBreakRateTypeIds.push(rate.id);
            }
        });

        return validBreakRateTypeIds;
    };

    const validateZeroHourBreaks = (receivedTimesheetEntries) => {
        let hasZeroHourBreaks = false;
        const validBreakRateTypeIds = getValidBreakRateTypeIds();

        for (let i = 0; i < receivedTimesheetEntries.length; i++) {
            const entry = receivedTimesheetEntries[i];

            if (
                !validBreakRateTypeIds.includes(entry.rateTypeId) ||
                !entry.timesheetBreaks ||
                !entry.startTime ||
                !entry.endTime
            )
                continue;

            for (let j = 0; j < entry.timesheetBreaks.length; j++) {
                const timesheetBreak = entry.timesheetBreaks[j];

                if (!timesheetBreak.startTime || !timesheetBreak.endTime) continue;

                if (timesheetBreak.startTime === timesheetBreak.endTime) {
                    setBreakError(i, j, 'startTime', 'Start and end time cannot be the same');
                    setBreakError(i, j, 'endTime', 'Start and end time cannot be the same');
                    hasZeroHourBreaks = true;
                }
            }
        }

        return hasZeroHourBreaks;
    };

    const validateBreakHoursOverlap = (receivedTimesheetEntries) => {
        let hasBreakHoursOverlap = false;
        const validBreakRateTypeIds = getValidBreakRateTypeIds();

        for (let i = 0; i < receivedTimesheetEntries.length; i++) {
            const entry = receivedTimesheetEntries[i];

            if (!validBreakRateTypeIds.includes(entry.rateTypeId) || !entry.timesheetBreaks)
                continue;

            const sortedBreaks = entry.timesheetBreaks.sort((a, b) =>
                a.startTime.localeCompare(b.startTime)
            );

            for (let j = 0; j < sortedBreaks.length - 1; j++) {
                const timesheetBreak = sortedBreaks[j];
                const breakEndTime = moment(timesheetBreak.endTime);

                const nextBreakIndex = j + 1;
                const nextBreak = sortedBreaks[nextBreakIndex];
                const nextBreakStartTime = moment(nextBreak.startTime);

                if (breakEndTime.isSameOrBefore(nextBreakStartTime)) continue;

                setBreakError(i, j, 'startTime', `Start time can't overlap`);
                setBreakError(i, j, 'endTime', `End time can't overlap`);
                setBreakError(i, nextBreakIndex, 'startTime', `Start time can't overlap`);
                setBreakError(i, nextBreakIndex, 'endTime', `End time can't overlap`);

                hasBreakHoursOverlap = true;
            }
        }

        return hasBreakHoursOverlap;
    };

    const validateBreakWithinEntry = (receivedTimesheetEntries) => {
        let hasOutOfBoundsBreaks = false;
        const validBreakRateTypeIds = getValidBreakRateTypeIds();

        for (let i = 0; i < receivedTimesheetEntries.length; i++) {
            const entry = receivedTimesheetEntries[i];

            if (
                !validBreakRateTypeIds.includes(entry.rateTypeId) ||
                !entry.timesheetBreaks ||
                !entry.startTime ||
                !entry.endTime
            )
                continue;

            const entryStart = moment(entry.startTime);
            const entryEnd = moment(entry.endTime);

            for (let j = 0; j < entry.timesheetBreaks.length; j++) {
                const timesheetBreak = entry.timesheetBreaks[j];

                if (!timesheetBreak.startTime || !timesheetBreak.endTime) continue;

                const breakStart = moment(timesheetBreak.startTime);
                const breakEnd = moment(timesheetBreak.endTime);

                let isBreakOutOfBounds = false;

                if (!breakStart.isBetween(entryStart, entryEnd, null, '[]')) {
                    setBreakError(i, j, 'startTime', 'Break time must be within shift time');
                    isBreakOutOfBounds = true;
                }

                if (!breakEnd.isBetween(entryStart, entryEnd, null, '[]')) {
                    setBreakError(i, j, 'endTime', 'Break time must be within shift time');
                    isBreakOutOfBounds = true;
                }

                if (isBreakOutOfBounds) hasOutOfBoundsBreaks = true;
            }
        }

        return hasOutOfBoundsBreaks;
    };

    const validateBreaks = ({ timesheetEntries: receivedTimesheetEntries }) => {
        const formattedEntries = formatTimesheetEntries(receivedTimesheetEntries);
        const hasZeroHourBreaks = validateZeroHourBreaks(formattedEntries);
        const hasBreakOutOfBounds = validateBreakWithinEntry(formattedEntries);

        if (hasZeroHourBreaks || hasBreakOutOfBounds) return false;

        const hasBreakOverlap = validateBreakHoursOverlap(formattedEntries);
        return !hasBreakOverlap;
    };

    const validateAssociatedRateType = ({ timesheetEntries: receivedTimesheetEntries }) => {
        let missingAssociatedRate = false;

        const rates = receivedTimesheetEntries.filter((entry) => entry.rateTypeId !== '');

        receivedTimesheetEntries.forEach((entry, index) => {
            let missingRate = false;
            const rateType = timesheet.booking.availableRates.find(
                (r) => r.id === entry.rateTypeId
            );
            if (
                !!rateType &&
                (rateType.category === 'Hours' || rateType.category === 'TeleHours') &&
                rateType.associatedRateType !== null
            ) {
                missingRate = !rates.find(
                    (r) =>
                        r.rateTypeId === rateType.associatedRateType &&
                        moment(r.transactionDate).diff(entry.transactionDate, 'hours') <= 48 &&
                        r.locationId === entry.locationId
                );
            }
            if (missingRate) {
                missingAssociatedRate = true;
                methods.setError(`timesheetEntries[${index}].rateTypeId`, {
                    type: 'manual',
                    message: `On-call shift is required`,
                });
            }
        });
        return missingAssociatedRate;
    };

    const validateNoFutureDates = (data) => {
        let noFutureDates = true;
        const today = new Date();

        ['timesheetEntries', 'mileageEntries'].forEach((entries) => {
            if (!data[entries]) return null;

            data[entries].forEach((entry, index) => {
                let transactionDate;

                // For timesheetEntries, check rateType and use startTime/endTime if necessary
                if (entries === 'timesheetEntries') {
                    const rateType = entry.rateTypeId
                        ? timesheet.booking.availableRates.find((r) => r.id === entry.rateTypeId)
                        : null;

                    if (
                        !!rateType &&
                        (rateType.category === 'Hours' || rateType.category === 'TeleHours')
                    ) {
                        const startTime = new Date(entry.startTime);
                        const endTime = new Date(entry.endTime);

                        if (startTime > today) {
                            noFutureDates = false;
                            methods.setError(`${entries}[${index}].startTime`, {
                                type: 'manual',
                                message:
                                    'Timesheets cannot be submitted with shift or mileage dates in the future.',
                            });
                        }

                        if (endTime > today) {
                            noFutureDates = false;
                            methods.setError(`${entries}[${index}].endTime`, {
                                type: 'manual',
                                message:
                                    'Timesheets cannot be submitted with shift or mileage dates in the future.',
                            });
                        }
                    } else if (rateType) {
                        // For other timesheet categories, check transactionDate
                        transactionDate = new Date(entry.transactionDate);
                        if (transactionDate > today) {
                            noFutureDates = false;
                            methods.setError(`${entries}[${index}].transactionDate`, {
                                type: 'manual',
                                message:
                                    'Timesheets cannot be submitted with shift or mileage dates in the future.',
                            });
                        }
                    }
                } else if (entries === 'mileageEntries') {
                    // For mileageEntries, always check transactionDate
                    if (entry.miles) {
                        transactionDate = new Date(entry.transactionDate);
                        if (transactionDate > today) {
                            noFutureDates = false;
                            methods.setError(`${entries}[${index}].transactionDate`, {
                                type: 'manual',
                                message:
                                    'Timesheets cannot be submitted with shift or mileage dates in the future.',
                            });
                        }
                    }
                }
            });
        });

        return noFutureDates;
    };

    const getHolidayEntryIndexesPerDay = (receivedTimesheetEntries, holidayRate) => {
        const holidayEntryIndexesPerDay = new Map();

        for (let i = 0; i < receivedTimesheetEntries.length; i++) {
            if (receivedTimesheetEntries[i].rateTypeId !== holidayRate.id) continue;

            const entryDate = receivedTimesheetEntries[i].transactionDate;
            let dayEntryIndexes = holidayEntryIndexesPerDay.get(entryDate);

            if (dayEntryIndexes) dayEntryIndexes.push(i);
            else dayEntryIndexes = [i];

            holidayEntryIndexesPerDay.set(entryDate, dayEntryIndexes);
        }

        return holidayEntryIndexesPerDay;
    };

    const hasMultipleHolidayShiftsPerDay = (holidayEntryIndexesPerDay) => {
        let hasMultipleHolidayShifts = false;

        holidayEntryIndexesPerDay.forEach((dayHolidayEntryIndexes) => {
            if (dayHolidayEntryIndexes.length < 2) return;

            dayHolidayEntryIndexes.forEach((index) => {
                methods.setError(`timesheetEntries[${index}].units`, {
                    type: 'manual',
                    message: `Max of 1 Holiday allowed per day.`,
                });
            });

            hasMultipleHolidayShifts = true;
        });

        return hasMultipleHolidayShifts;
    };

    const validateHolidayShifts = ({ timesheetEntries: recievedTimesheetEntries }) => {
        const holidayRate = timesheet.booking.availableRates.find(
            (rate) => rate.displayName === RateDisplayNameEnum.HolidayShift
        );
        if (!holidayRate) return true;

        const holidayEntryIndexesPerDay = getHolidayEntryIndexesPerDay(
            recievedTimesheetEntries,
            holidayRate
        );
        if (!holidayEntryIndexesPerDay) return true;

        return !hasMultipleHolidayShiftsPerDay(holidayEntryIndexesPerDay);
    };

    const revalidateErrors = async (data) => {
        methods.clearErrors();

        await detectCommentWarnings(data);
        await methods.trigger();

        validateHoursOverlap(data);
        validateBreaks(data);
        validateAssociatedRateType(data);
        validateNoFutureDates(data);
        validateHolidayShifts(data);
    };

    const detectHolidayShift = async ({ timesheetEntries: receivedTimesheetEntries }) => {
        const data = methods.getValues();
        revalidateErrors(data);

        const holidayRate = timesheet.booking.availableRates.find(
            (rate) => rate.displayName === RateDisplayNameEnum.HolidayShift
        );

        if (!holidayRate) return false;

        let holidays = officialLTHolidays;

        if (!officialLTHolidays) {
            holidays = await getHolidays();
            setOfficialLTHolidays(holidays);
        }

        const entryDates = [
            ...new Set(receivedTimesheetEntries.map((entry) => entry.transactionDate)),
        ];

        // eslint-disable-next-line no-restricted-syntax
        for (const date of entryDates) {
            const dateHasBeenChecked = holidayPromptCheckedDates.some(
                (checkedDate) => checkedDate === date
            );

            if (dateHasBeenChecked) continue;

            const entriesOnDate = receivedTimesheetEntries.filter(
                (entry) => entry.transactionDate === date
            );

            let lastEntryOnDate = entriesOnDate[entriesOnDate.length - 1];
            if (isCallBackEntry(lastEntryOnDate)) {
                const [relatedEntry] = receivedTimesheetEntries.filter(
                    (entry) => entry.id === lastEntryOnDate.relatedEntryId
                );
                lastEntryOnDate = relatedEntry;
            }

            let numChildrenOfLastEntryOnDate = 0;

            const childrenOfLastEntryOnDate = receivedTimesheetEntries.filter(
                (entry) => entry.relatedEntryId === lastEntryOnDate.id
            );

            if (childrenOfLastEntryOnDate.length > 0) {
                // eslint-disable-next-line no-restricted-syntax, no-unused-vars
                for (const child of childrenOfLastEntryOnDate) {
                    numChildrenOfLastEntryOnDate += 1;
                }
            }

            const lastEntryOnDateIndex = receivedTimesheetEntries.indexOf(lastEntryOnDate);
            const insertIndex = lastEntryOnDateIndex + numChildrenOfLastEntryOnDate + 1;

            const officialHolidayOnDate = holidays.find(
                (holiday) => holiday.date === moment(date).format('YYYY-MM-DD')
            );

            const hasNormalShiftOnDate = entriesOnDate.some(
                (entry) =>
                    entry.rateTypeId !== '' &&
                    entry.rateTypeId !== holidayRate.id &&
                    !isCallBackEntry(entry)
            );

            const hasHolidayShiftOnDate = entriesOnDate.some(
                (entry) => entry.rateTypeId === holidayRate.id
            );

            /**
             * Case A for LT official holidays  |     IS Official Holiday |    Normal Shift | NO Holiday Shift
             * Case B for LT official holidays  |     IS Official Holiday | NO Normal Shift |    Holiday Shift
             * Case for "user-entered" holidays | IS NOT Official Holiday | NO Normal Shift |    Holiday Shift
             */

            // Case A for LT official holidays (IS Official Holiday + Normal Shift + NO Holiday Shift)
            if (!!officialHolidayOnDate && hasNormalShiftOnDate && !hasHolidayShiftOnDate) {
                const displayedHolidayDate = moment(officialHolidayOnDate.date).format(
                    'MM-DD-YYYY'
                );

                const newHolidayPromptProperties = {
                    name: officialHolidayOnDate.name,
                    date: displayedHolidayDate,
                    rateTypeId: holidayRate.id,
                    transactionDate: date,
                    locationId: entriesOnDate[0].locationId,
                    index: insertIndex,
                };

                setHolidayPromptProperties(newHolidayPromptProperties);
                setOpenHolidayPrompt(true);

                setHolidayPromptCheckedDates([...holidayPromptCheckedDates, date]);
                setDoRerunHolidayPrompt(true);

                return true;
            }

            // Case B for LT official holidays (IS Official Holiday + NO Normal Shift + Holiday Shift)
            if (!!officialHolidayOnDate && !hasNormalShiftOnDate && hasHolidayShiftOnDate) {
                const displayedHolidayDate = moment(officialHolidayOnDate.date).format(
                    'MM-DD-YYYY'
                );

                const newHolidayPromptProperties = {
                    name: officialHolidayOnDate.name,
                    date: displayedHolidayDate,
                    rateTypeId: '',
                    transactionDate: date,
                    locationId: entriesOnDate[0].locationId,
                    index: insertIndex,
                };

                setHolidayPromptProperties(newHolidayPromptProperties);
                setOpenHolidayPrompt(true);

                setHolidayPromptCheckedDates([...holidayPromptCheckedDates, date]);
                setDoRerunHolidayPrompt(true);

                return true;
            }

            // Case for "user-entered" holidays (IS NOT Official Holiday + NO Normal Shift + Holiday Shift)
            if (!officialHolidayOnDate && !hasNormalShiftOnDate && hasHolidayShiftOnDate) {
                const displayedHolidayDate = moment(date).format('MM-DD-YYYY');

                const newHolidayPromptProperties = {
                    name: '',
                    date: displayedHolidayDate,
                    rateTypeId: '',
                    transactionDate: date,
                    locationId: entriesOnDate[0].locationId,
                    index: insertIndex,
                };

                setHolidayPromptProperties(newHolidayPromptProperties);
                setOpenHolidayPrompt(true);

                setHolidayPromptCheckedDates([...holidayPromptCheckedDates, date]);
                setDoRerunHolidayPrompt(true);

                return true;
            }
        }

        setDoRerunHolidayPrompt(false);
        return false;
    };

    const generateDateLookup = (dateWeekEnding, bookingStart, bookingEnd) => {
        let dates = [];
        const format = 'YYYY-MM-DDTHH:mm:ss';
        const startDate = moment.tz(bookingStart, 'Greenwich');
        const endDate = moment.tz(bookingEnd, 'Greenwich');
        for (let index = 0; index < 7; index++) {
            const date = moment.tz(dateWeekEnding, 'Greenwich').subtract(index, 'day');
            const inBooking = date.isSameOrAfter(startDate) && date.isSameOrBefore(endDate);
            if (inBooking) {
                dates = [
                    ...dates,
                    {
                        label: date.format('ddd M/D'),

                        value: date.format(format),
                    },
                ];
            }
        }
        const sortedDates = dates.sort((a, b) => moment(a.value) - moment(b.value));
        setDateLookup(sortedDates);
    };

    const convertUTCtoTime = (utcString, timeZoneBooking) => {
        let utcDateTime = utcString;
        if (utcString !== null) {
            utcDateTime = moment(utcString).tz(timeZoneBooking).format('HH:mm');
        }
        return utcDateTime;
    };

    const mapTimeToLocationTimezone = (recievedTimesheet) => {
        recievedTimesheet.timesheetEntries.map((entry) => {
            const timesheetEntry = entry;
            const timeZoneBooking =
                recievedTimesheet?.booking?.locations?.find(
                    (location) => location.id === timesheetEntry?.locationId
                )?.timeZone || moment.tz.guess();
            const { startTime } = timesheetEntry;
            const { endTime } = timesheetEntry;
            timesheetEntry.startTime = convertUTCtoTime(startTime, timeZoneBooking);
            timesheetEntry.endTime = convertUTCtoTime(endTime, timeZoneBooking);
            timesheetEntry.transactionDate = moment(timesheetEntry.transactionDate)
                .utc()
                .format('YYYY-MM-DDTHH:mm:ss');

            timesheetEntry.timesheetBreaks = timesheetEntry.timesheetBreaks.sort((a, b) =>
                a.startTime.localeCompare(b.startTime)
            );
            timesheetEntry.timesheetBreaks.map((tsBreak) => {
                const timesheetBreak = tsBreak;
                timesheetBreak.startTime = convertUTCtoTime(
                    timesheetBreak.startTime,
                    timeZoneBooking
                );
                timesheetBreak.endTime = convertUTCtoTime(timesheetBreak.endTime, timeZoneBooking);
                return timesheetBreak;
            });
            return timesheetEntry;
        });
        recievedTimesheet.mileageEntries.map((mEntry) => {
            const mileageEntry = mEntry;
            mileageEntry.transactionDate = moment(mileageEntry.transactionDate)
                .utc()
                .format('YYYY-MM-DDTHH:mm:ss');
            return mileageEntry;
        });
        return recievedTimesheet;
    };

    const checkIfReadOnly = (review) =>
        review.status !== 'NotStarted' &&
        review.status !== 'PendingSubmission' &&
        review.status !== 'Rejected' &&
        review.status !== 'DidNotWork';

    async function fetchTimesheetById() {
        setIsLoaded(false);
        try {
            const receivedTimesheetDetails = await getTimesheetById(externalId, id);
            const enableHistory = historyEnabledStatuses.includes(receivedTimesheetDetails.status);
            setHistoryEnabled(enableHistory && isAdminApp);
            const timesheetDetails = mapTimeToLocationTimezone(receivedTimesheetDetails);
            generateDateLookup(
                weekEnding,
                timesheetDetails.booking.startDate,
                timesheetDetails.booking.endDate
            );
            const formattedReadOnlyLocations =
                forceEditMode && timesheetDetails.isLatestTimesheetVersion
                    ? []
                    : timesheetDetails.timesheetReviews
                          ?.map((review) =>
                              readOnlyStatuses.indexOf(review.status) > -1
                                  ? review.locationId
                                  : null
                          )
                          .filter(Boolean) || [];
            setReadOnlyLocations(formattedReadOnlyLocations);
            const readOnlyReviewCheck =
                timesheetDetails.timesheetReviews.length > 0
                    ? timesheetDetails.timesheetReviews.every(checkIfReadOnly)
                    : false;
            const readOnlyCheck = readOnlyStatuses.indexOf(timesheetDetails.status) > -1;
            setIsReadOnly((readOnlyReviewCheck || readOnlyCheck) && !forceEditMode);
            setIsPaidApproved(
                !!(timesheetDetails.status === 'Approved' || timesheetDetails.status === 'Paid')
            );
            setTimesheet(timesheetDetails);
            setIsMileageExpected(timesheetDetails.booking.mileageExpected);
            setIsLoaded(true);
        } catch (fetchTimesheetError) {
            setErrorLoadingTimesheet('Could not load timesheet');
            setIsLoaded(true);
            console.error(fetchTimesheetError);
        }
    }

    useEffect(() => {
        if (doRerunHolidayPrompt && !openHolidayPrompt) {
            setDoRerunHolidayPrompt(false);
            const data = methods.getValues();
            detectHolidayShift(data);
        }
    }, [timesheetEntries]);

    useEffect(() => {
        commentWarning.current = false;
        const contextwarningtimesheet = getTimesheetCommentWarnings();
        const calcCommentWordList = [];
        if (!contextwarningtimesheet.includes(id)) {
            Object.entries(watchedValues).forEach((watchedKey) => {
                const watchedValue = watchedValues[watchedKey];
                if (watchedValue) {
                    const containsWords = containsAny(watchedValue, wordList.words);
                    if (containsWords.length > 0) {
                        commentWarning.current = true;
                        calcCommentWordList.push(...containsWords);
                    }
                }
            });

            for (let i = 0; i < calcCommentWordList.length; i++) {
                calcCommentWordList[i] =
                    calcCommentWordList[i].charAt(0).toUpperCase() +
                    calcCommentWordList[i].substr(1);
            }

            commentWordList.current = [...new Set(calcCommentWordList)];
        }
    }, [watchedValues]);

    useEffect(() => {
        if (formRef.current) {
            formRef.current.focus();
        }
        window.scrollTo(0, 0);
    }, [isLoaded]);

    useEffect(() => {
        fetchTimesheetById();
    }, [id, weekEnding]);

    function generateNextId() {
        const entries = methods.getValues().timesheetEntries;
        const lowIdItem = entries.reduce((prev, curr) => (prev.id < curr.id ? prev : curr));
        // eslint-disable-next-line no-bitwise
        return !lowIdItem | (lowIdItem.id > -1) ? -1 : lowIdItem.id - 1;
    }

    const setDefaultValues = () => {
        let timesheetEntriesDefault = timesheet.timesheetEntries.sort(
            (a, b) => new Date(a.transactionDate) - new Date(b.transactionDate)
        );

        // Group timesheetEntries by relatedEntryId or form individual groups for entries without relatedEntryId
        const groups = {};
        timesheetEntriesDefault.forEach((entry, index) => {
            if (entry.id === 0) {
                // eslint-disable-next-line no-param-reassign
                entry.id = -(index + 1);
            }
            const { relatedEntryId } = entry;
            if (relatedEntryId) {
                if (!groups[relatedEntryId]) {
                    groups[relatedEntryId] = [];
                }
                groups[relatedEntryId].push(entry);
            } else {
                // Form individual groups for entries without relatedEntryId
                groups[entry.id] = [entry];
            }
        });

        const sortEntriesWithinGroup = (group) =>
            group.sort((a, b) => {
                const dateA = new Date(a.transactionDate);
                const dateB = new Date(b.transactionDate);
                if (dateA.getTime() !== dateB.getTime()) {
                    return dateA - dateB;
                }
                // Sort by start time if it exists
                if (a.startTime && b.startTime) {
                    return a.startTime.localeCompare(b.startTime);
                }
                // If start time doesn't exist, maintain the existing order
                return 0;
            });

        // sort groups by the transactionDate of their first entry
        const sortGroupsByTransactionDate = (groupsToSort) =>
            Object.values(groupsToSort).sort((a, b) => {
                const dateA = new Date(a[0].transactionDate);
                const dateB = new Date(b[0].transactionDate);
                return dateA - dateB;
            });

        // Sort groups by transactionDate
        const sortedGroups = sortGroupsByTransactionDate(groups);

        // Sort entries within each group
        sortedGroups.forEach((group) => {
            sortEntriesWithinGroup(group);
        });

        // Flatten sortedGroups into an array while keeping the order of groups
        const sortedEntries = sortedGroups.flatMap((group) => group);

        timesheetEntriesDefault = sortedEntries.map((entry, index) => ({
            id: entry.id === 0 ? -(index + 1) : entry.id,
            transactionDate: entry.transactionDate,
            locationId: entry.locationId ? entry.locationId : '',
            rateTypeId: entry.rateTypeId ? entry.rateTypeId : '',
            relatedEntryId: entry.relatedEntryId ? entry.relatedEntryId : '',
            startTime: entry.startTime ? entry.startTime : '',
            endTime: entry.endTime ? entry.endTime : '',
            units: entry.units ? entry.units.toString() : '',
            comment: entry.comment ? entry.comment : '',
            timesheetBreaks: entry.timesheetBreaks,
            isAddedEntry: false,
        }));

        const mileageEntriesDefault = timesheet.mileageEntries
            .sort((a, b) => new Date(a.transactionDate) - new Date(b.transactionDate))
            .map((entry) => ({
                id: entry.id,
                transactionDate: entry.transactionDate,
                locationId: entry.locationId ? entry.locationId : '',
                miles: entry.miles ? entry.miles : '',
                comment: entry.comment ? entry.comment : '',
            }));
        return { timesheetEntries: timesheetEntriesDefault, mileageEntries: mileageEntriesDefault };
    };

    useEffect(() => {
        if (timesheet && dateLookup) {
            methods.reset(setDefaultValues());
        }
    }, [methods.reset, timesheet, dateLookup]);

    useEffect(() => {
        async function getConfigurationSettings() {
            const fallbackValue = { words: ['break', 'lunch', 'call'] };
            const aWordlist = await getConfigurationSetting(
                'Timesheets:Comments:WordList',
                false,
                fallbackValue
            );
            setWordList(aWordlist);
        }

        getConfigurationSettings();
    }, []);

    const formatMileageEntries = (entries) => {
        if (entries) {
            return entries
                .filter((entry) => entry.transactionDate)
                .map((entry) => ({
                    ...entry,
                    transactionDate: moment.tz(entry.transactionDate, 'Greenwich').format(),
                    locationId: entry.locationId === '' ? null : entry.locationId,
                    miles: entry.miles === '' ? null : entry.miles,
                    comment: entry.comment === '' ? null : entry.comment,
                }));
        }
        return [];
    };

    const formatTimesheet = (data) => {
        const newTimesheet = cloneDeep(timesheet);
        if (!settingDidNotWork.current) {
            newTimesheet.status =
                timesheet.status === TimesheetStatusEnumApi.NotStarted && !isDirty
                    ? TimesheetStatusEnumApi.NotStarted
                    : TimesheetStatusEnumApi.PendingSubmission;
        }
        newTimesheet.timesheetEntries = formatTimesheetEntries(data.timesheetEntries);
        newTimesheet.mileageEntries = formatMileageEntries(data.mileageEntries);
        return newTimesheet;
    };

    const onSave = async (data) => {
        const tempBackupTimesheetEntries = data.timesheetEntries;
        const tempBackupMileageEntries = data.mileageEntries;
        setIsLoaded(false);
        const newTimesheet = formatTimesheet(data);
        const timesheetId = newTimesheet.id;
        if (
            timesheet.status === TimesheetStatusEnumApi.Approved ||
            timesheet.status === TimesheetStatusEnumApi.TimeNotEntered
        ) {
            // Editing an approved Raw Timesheet - set to Pending Submission; Backend will create new TS version
            newTimesheet.status = timesheet.status;
            newTimesheet.originalRawTimesheetId = timesheetId;
            newTimesheet.id = 0;
        }
        if (newTimesheet.status === TimesheetStatusEnumApi.NotStarted) {
            setIsLoaded(true);
            history.push('/timesheets');
        } else {
            try {
                if (newTimesheet.id || newTimesheet.id === 0) {
                    // call update
                    await saveTimesheet(newTimesheet, timesheetId, false);
                } else {
                    // POST
                    await saveTimesheet(newTimesheet);
                }
                if (setRefreshNotifications) {
                    setRefreshNotifications();
                }
                setIsLoaded(true);
                history.push('/timesheet/save');
            } catch (saveError) {
                setIsLoaded(true);
                let message = formatErrorMessage(saveError);
                if (message === 'An error has occurred.')
                    message = 'Timesheet has failed to be saved. Please try again.';
                setError(message);
                console.error(message);

                if (tempBackupTimesheetEntries) {
                    timesheetRemove();
                    tempBackupTimesheetEntries.forEach((backupEntry) => {
                        console.log(backupEntry);
                        timesheetAppend({
                            id: !backupEntry.id ? generateNextId() : backupEntry.id,
                            transactionDate: !backupEntry.transactionDate
                                ? ''
                                : backupEntry.transactionDate.slice(
                                      0,
                                      backupEntry.transactionDate.length - 1
                                  ),
                            locationId: !backupEntry.locationId ? '' : backupEntry.locationId,
                            rateTypeId: !backupEntry.rateTypeId ? '' : backupEntry.rateTypeId,
                            relatedEntryId: !backupEntry.relatedEntryId
                                ? ''
                                : backupEntry.relatedEntryId,
                            units: !backupEntry.units ? '' : backupEntry.units,
                            startTime: !backupEntry.startTime
                                ? ''
                                : moment(backupEntry.startTime).format('HH:mm'),
                            endTime: !backupEntry.endTime
                                ? ''
                                : moment(backupEntry.endTime).format('HH:mm'),
                            comment: !backupEntry.comment ? '' : backupEntry.comment,
                            isAddedEntry: false,
                        });
                    });
                }

                if (tempBackupMileageEntries) {
                    mileageRemove();

                    tempBackupMileageEntries.forEach((backupEntry) => {
                        mileageAppend({
                            id: backupEntry.id,
                            transactionDate: !backupEntry.transactionDate
                                ? ''
                                : backupEntry.transactionDate.slice(
                                      0,
                                      backupEntry.transactionDate.length - 1
                                  ),
                            locationId: !backupEntry.locationId ? '' : backupEntry.locationId,
                            miles: !backupEntry.miles ? '' : backupEntry.miles,
                            comment: !backupEntry.comment ? '' : backupEntry.comment,
                        });
                    });
                }
            }
        }
    };

    const onSubmit = async (data) => {
        const tempBackupTimesheetEntries = data.timesheetEntries;
        const tempBackupMileageEntries = data.mileageEntries;
        setIsLoaded(false);
        const newTimesheet = formatTimesheet(data);
        const timesheetId = newTimesheet.id;
        let editingRawTimesheet = false;
        if (
            timesheet.status === TimesheetStatusEnumApi.Approved ||
            timesheet.status === TimesheetStatusEnumApi.TimeNotEntered
        ) {
            editingRawTimesheet = true;
        }
        newTimesheet.timesheetEntries = newTimesheet.timesheetEntries.filter(
            (entry) => entry.locationId && entry.rateTypeId
        );
        newTimesheet.mileageEntries = newTimesheet.mileageEntries.filter(
            (entry) => entry.locationId
        );
        if (
            !settingDidNotWork.current &&
            newTimesheet?.status === TimesheetStatusEnumApi.DidNotWork
        ) {
            newTimesheet.status = TimesheetStatusEnumApi.PendingSubmission;
        }
        try {
            if (editingRawTimesheet) {
                newTimesheet.status = timesheet.status;
                newTimesheet.originalRawTimesheetId = timesheetId;
                newTimesheet.id = 0;
                const response = await saveTimesheet(newTimesheet, timesheetId);
                newTimesheet.id = response.id;
            } else if (newTimesheet.id || newTimesheet.id === 0) {
                // call update
                await saveTimesheet(newTimesheet, newTimesheet.id);
            } else if (!newTimesheet.id) {
                // call save
                const response = await saveTimesheet(newTimesheet);
                newTimesheet.id = response.id;
            }
            setIsLoaded(true);
            let goTo = '/timesheets';
            if (isAdminApp) {
                if (!settingDidNotWork.current)
                    goTo = `/clinician/${newTimesheet?.clinicianId}/timesheet/${newTimesheet?.id}/review?editable=true`;
            } else if (!settingDidNotWork.current) goTo = `/timesheet/${newTimesheet.id}/review`;
            settingDidNotWork.current = false;
            history.push(goTo);
        } catch (submitError) {
            setIsLoaded(true);
            setEmptyTimesheetModalOpen(false);
            let message = formatErrorMessage(submitError);
            if (message === 'An error has occurred.')
                message = 'Timesheet has failed to be submitted. Please try again.';
            setError(message);
            console.error(submitError);

            if (tempBackupTimesheetEntries) {
                timesheetRemove();
                tempBackupTimesheetEntries.forEach((backupEntry) => {
                    timesheetAppend({
                        id: !backupEntry.id ? generateNextId() : backupEntry.id,
                        transactionDate: !backupEntry.transactionDate
                            ? ''
                            : backupEntry.transactionDate.slice(
                                  0,
                                  backupEntry.transactionDate.length - 1
                              ),
                        locationId: !backupEntry.locationId ? '' : backupEntry.locationId,
                        rateTypeId: !backupEntry.rateTypeId ? '' : backupEntry.rateTypeId,
                        relatedEntryId: !backupEntry.relatedEntryId
                            ? ''
                            : backupEntry.relatedEntryId,
                        units: !backupEntry.units ? '' : backupEntry.units,
                        startTime: !backupEntry.startTime
                            ? ''
                            : moment(backupEntry.startTime).format('HH:mm'),
                        endTime: !backupEntry.endTime
                            ? ''
                            : moment(backupEntry.endTime).format('HH:mm'),
                        comment: !backupEntry.comment ? '' : backupEntry.comment,
                        isAddedEntry: false,
                    });
                });
            }

            if (tempBackupMileageEntries) {
                mileageRemove();
                tempBackupMileageEntries.forEach((backupEntry) => {
                    mileageAppend({
                        id: backupEntry.id,
                        transactionDate: !backupEntry.transactionDate
                            ? ''
                            : backupEntry.transactionDate.slice(
                                  0,
                                  backupEntry.transactionDate.length - 1
                              ),
                        locationId: !backupEntry.locationId ? '' : backupEntry.locationId,
                        miles: !backupEntry.miles ? '' : backupEntry.miles,
                        comment: !backupEntry.comment ? '' : backupEntry.comment,
                    });
                });
            }
        }
    };

    const debouncedOnSaveOrSubmit = useDebouncedCallback(
        (action, data) => {
            if (action === 'save') {
                onSave(data);
            } else if (action === 'submit') {
                onSubmit(data);
            }
        },
        5000,
        { leading: true }
    );

    const validateNoDates = (data) => {
        const triggers = [];
        ['timesheetEntries', 'mileageEntries'].forEach((entries) => {
            if (!data[entries]) return null;
            data[entries].forEach((entry, index) => {
                const trigger = !entry.transactionDate
                    ? `${entries}[${index}].transactionDate`
                    : null;
                if (trigger) triggers.push(trigger);
            });
        });
        return triggers;
    };

    const validateNoAMPM = (data) => {
        const triggers = [];
        console.log(data);
        ['timesheetEntries'].forEach((entries) => {
            data[entries].forEach((entry, index) => {
                const triggerStart =
                    !entry.startTime && entry.rateTypeId ? `${entries}[${index}].startTime` : null;
                const triggerEnd =
                    !entry.endTime && entry.rateTypeId ? `${entries}[${index}].endTime` : null;

                if (triggerStart) triggers.push(triggerStart);
                if (triggerEnd) triggers.push(triggerEnd);

                // Break check
                if (entry.timesheetBreaks) {
                    entry.timesheetBreaks.forEach((breakEntry, breakIndex) => {
                        const triggerBreakStart = !breakEntry.startTime
                            ? `${entries}[${index}].timesheetBreaks[${breakIndex}].startTime`
                            : null;
                        const triggerBreakEnd = !breakEntry.endTime
                            ? `${entries}[${index}].timesheetBreaks[${breakIndex}].endTime`
                            : null;

                        if (triggerBreakStart) triggers.push(triggerBreakStart);
                        if (triggerBreakEnd) triggers.push(triggerBreakEnd);
                    });
                }
            });
        });
        return triggers;
    };

    const validateSave = async () => {
        setIsSave(true);
        methods.clearErrors();
        const data = methods.getValues();
        const noDates = validateNoDates(data);
        const noAMPM = validateNoAMPM(data);
        const validDates = await methods.trigger(noDates);
        const validAMPM = await methods.trigger(noAMPM);

        if (validDates && validAMPM) {
            debouncedOnSaveOrSubmit('save', data);
        }
    };

    const isEmptyTimesheet = ({
        timesheetEntries: receivedTimesheetEntries,
        mileageEntries: argMileageEntries,
    }) => {
        const hasNoRateTypesOrComments = !receivedTimesheetEntries.some(
            (e) => !!e.rateTypeId || !!e.comment
        );
        const hasNoMileage = !argMileageEntries ? true : !argMileageEntries.some((e) => !!e.miles);

        return hasNoRateTypesOrComments && hasNoMileage;
    };

    const validateSubmitAfterEmptyCheck = async (skipMissingHolidayShiftValidation) => {
        if (isSave) {
            setIsSave(false);
        }

        methods.clearErrors();
        const data = methods.getValues();
        const isCommentWarningsDetected = await detectCommentWarnings(data);
        const isMissingHolidayShift = skipMissingHolidayShiftValidation
            ? false
            : await detectHolidayShift(data);
        const valid = await methods.trigger();

        const hasOverlap = validateHoursOverlap(data);
        const hasValidBreaks = validateBreaks(data);
        const missingAssociatedRate = validateAssociatedRateType(data);
        const noFutureDates = validateNoFutureDates(data);
        const hasValidHolidayShifts = validateHolidayShifts(data);

        if (!valid) {
            setEmptyTimesheetModalOpen(false);
            return;
        }

        if (
            !hasOverlap &&
            hasValidBreaks &&
            valid &&
            !missingAssociatedRate &&
            !isMissingHolidayShift &&
            !isCommentWarningsDetected &&
            hasValidHolidayShifts &&
            noFutureDates
        ) {
            methods.handleSubmit((submitData) => debouncedOnSaveOrSubmit('submit', submitData))();
        }
        window.Appcues.track('Review Timesheet Before Submitting (Review)', {
            key: 'Click the Review button',
            description: 'A user is moving to the Review screen prior to submitting',
        });
    };

    const validateSubmit = async () => {
        const data = methods.getValues();

        if (isEmptyTimesheet(data)) {
            setEmptyTimesheetModalOpen(true);
            return;
        }

        return validateSubmitAfterEmptyCheck(false);
    };

    const formatPeriod = (unformattedWeekEnding) => {
        const endDate = moment(unformattedWeekEnding).format('MMM D, YYYY');
        const startDate = moment(unformattedWeekEnding).subtract(6, 'days').format('MMM D');
        return `Week of ${startDate} - ${endDate}`;
    };

    const handleDirtyCancel = () => {
        if (isDirty || cleared) {
            setCancelModalOpen(true);
        } else {
            history.push('/timesheets');
        }
    };

    const handleRecall = async () => {
        setRecallWarningDialogOpen(false);
        setIsLoaded(false);
        const data = methods.getValues();
        const path = `/timesheet/${timesheet.id}/edit?weekEnding=${timesheet.weekEnding}`;
        const newTimesheet = formatTimesheet(data);
        try {
            const currentTimesheet = await getTimesheetById(externalId, timesheet.id);
            setRecallErrorType('updated');
            const currentTimsheetHasEntryInRecallableStatus =
                currentTimesheet?.timesheetReviews?.some(
                    (review) => review.status === TimesheetStatusEnumApi.Submitted
                );
            if (!currentTimsheetHasEntryInRecallableStatus) {
                setRecallErrorDialogOpen(true);
                setIsLoaded(true);
            } else {
                newTimesheet.status = TimesheetStatusEnumApi.PendingSubmission;
                await saveTimesheet(newTimesheet, timesheet.id, true);
                await fetchTimesheetById();
                history.replace(path);
            }
        } catch (recallError) {
            setIsLoaded(true);
            let message = formatErrorMessage(recallError);
            if (message === 'An error has occurred.')
                message = 'Timesheet has failed to be saved. Please try again.';
            setError(message);
            console.error(message);
        }
    };

    const resetEntries = (entries, key) => {
        if (!entries) {
            return [];
        }

        const isTimesheetEntry = key === 'timesheetEntry';
        const newTimesheetEntry = {
            id: 0,
            transactionDate: '',
            locationId: '',
            rateTypeId: '',
            relatedEntryId: '',
            startTime: '',
            endTime: '',
            units: '',
            comment: '',
        };

        let newEntries = entries
            .map((entry, index) => {
                const canReset = !readOnlyLocations.includes(entry.locationId);
                if (canReset) {
                    return isTimesheetEntry && entry.transactionDate
                        ? {
                              ...newTimesheetEntry,
                              id: -(index + 1),
                              transactionDate: entry.transactionDate,
                          }
                        : null;
                }
                return entry;
            })
            .filter(Boolean);

        if (isTimesheetEntry) {
            // Only include entries where transactionDate is in dateLookup or is read only
            newEntries = newEntries.filter((entry) =>
                dateLookup.some(
                    (d) =>
                        readOnlyLocations.includes(entry.locationId) ||
                        d.value === entry.transactionDate
                )
            );

            // Add back missing days
            dateLookup.forEach((date) => {
                const exists = newEntries.some((entry) => entry.transactionDate === date.value);
                if (!exists) {
                    newEntries = [
                        ...newEntries,
                        {
                            ...newTimesheetEntry,
                            id: -(newEntries.length + 1),
                            transactionDate: date.value,
                        },
                    ];
                }
            });

            // Only 1 blank entry per day (don't filter our any read-only entries)
            newEntries = newEntries.filter(
                (entry, index, self) =>
                    readOnlyLocations.includes(entry.locationId) ||
                    self.findIndex((e) => e.transactionDate === entry.transactionDate) === index
            );
        }

        return newEntries.sort((a, b) => new Date(a.transactionDate) - new Date(b.transactionDate));
    };

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setError(null);
    };

    const handleClear = () => {
        const data = methods.getValues();
        const updatedTimesheetEntries = resetEntries(data.timesheetEntries, 'timesheetEntry');
        const updatedMileageEntries = resetEntries(data.mileageEntries, 'mileageEntry');
        setTotalTimesheetHours(0);
        methods.reset({
            timesheetEntries: updatedTimesheetEntries,
            mileageEntries: updatedMileageEntries,
        });
        setCleared(true);
        setClearDialogOpen(false);
        setDoRerunHolidayPrompt(false);
        setHolidayPromptCheckedDates([]);
        setHasSelectedYesOnHolidayPrompt(false);
    };

    const isBlankEntry = (isMileageEntry, entry) => {
        if (isMileageEntry) {
            return (
                entry.transactionDate === '' &&
                entry.locationId === '' &&
                entry.miles === '' &&
                entry.comment === ''
            );
        }
        return (
            entry.locationId === '' &&
            entry.rateTypeId === '' &&
            entry.startTime === '' &&
            entry.endTime === '' &&
            entry.units === '' &&
            entry.comment === ''
        );
    };
    const handleRemove = (entry, index) => {
        const isMileageEntry = Object.prototype.hasOwnProperty.call(entry, 'miles');
        const blankEntry = isBlankEntry(isMileageEntry, entry);
        if (blankEntry && isMileageEntry) {
            mileageRemove(index);
        } else if (blankEntry && !isMileageEntry) {
            timesheetRemove(index);
        } else {
            setRemoveDialogOpen({ isMileageEntry, index });
        }
    };

    const renderEditButtons = () => {
        const recallOptionAvailable = timesheet?.timesheetReviews?.some(
            (review) => review.status === TimesheetStatusEnumApi.Submitted
        );
        const editOptionsAvailable =
            timesheet?.timesheetReviews?.some(
                (review) =>
                    review.status === TimesheetStatusEnumApi.NotStarted ||
                    review.status === TimesheetStatusEnumApi.PendingSubmission ||
                    review.status === TimesheetStatusEnumApi.Rejected ||
                    review.status === TimesheetStatusEnumApi.DidNotWork
            ) ||
            timesheet?.status === TimesheetStatusEnumApi.NotStarted ||
            timesheet?.status === TimesheetStatusEnumApi.PendingSubmission ||
            timesheet?.status === TimesheetStatusEnumApi.DidNotWork ||
            !timesheet?.status ||
            (forceEditMode && timesheet.isLatestTimesheetVersion);
        return (
            <>
                <Hidden only={editOptionsAvailable ? [] : ['xs', 'sm', 'md', 'lg', 'xl']}>
                    <Grid item xs={isMobile ? 12 : undefined}>
                        <Button
                            variant="contained"
                            sx={{
                                '&.MuiButtonBase-root.MuiButton-root': {
                                    color: '#5F6A7E',
                                    backgroundColor: '#e0e0e0',
                                    '&:hover': {
                                        backgroundColor: '#d5d5d5',
                                    },
                                },
                            }}
                            className={classes.mobileButton}
                            onClick={handleDirtyCancel}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Hidden>
                <Hidden only={editOptionsAvailable ? [] : ['xs', 'sm', 'md', 'lg', 'xl']}>
                    <Grid item xs={isMobile ? 12 : undefined}>
                        <Button
                            variant="contained"
                            color="primary"
                            classes={{ root: classes.saveButton }}
                            className={classes.mobileButton}
                            onClick={validateSave}
                        >
                            Save
                        </Button>
                    </Grid>
                </Hidden>
                <Hidden only={editOptionsAvailable ? [] : ['xs', 'sm', 'md', 'lg', 'xl']}>
                    <Grid item xs={isMobile ? 12 : undefined}>
                        <Button
                            variant="contained"
                            classes={{ root: classes.containedSuccess }}
                            className={classes.mobileButton}
                            onClick={() => validateSubmit()}
                        >
                            Review
                        </Button>
                    </Grid>
                </Hidden>
                <Hidden only={recallOptionAvailable ? [] : ['xs', 'sm', 'md', 'lg', 'xl']}>
                    <Grid item xs={isMobile ? 12 : undefined}>
                        <Button
                            variant="contained"
                            classes={{ root: classes.cancelButton }}
                            className={classes.mobileButton}
                            onClick={() => setRecallWarningDialogOpen(true)}
                        >
                            Recall
                        </Button>
                    </Grid>
                </Hidden>
            </>
        );
    };

    const renderClinicianHeader = () => (
        <Grid container direction="column" spacing={2}>
            <Grid item>
                <Button
                    variant="text"
                    sx={{ color: '#0077C8 !important' }}
                    startIcon={<ChevronLeft />}
                    onClick={() => {
                        if (isDirty || cleared) {
                            setCancelModalOpen(true);
                        } else {
                            history.push('/timesheets');
                        }
                    }}
                >
                    <Typography variant="overline" className={classes.overline1}>
                        {t('submitTimesheet:LINKS.GO_BACK_TO_MY_TIMESHEETS')}
                    </Typography>
                </Button>
            </Grid>
            <Grid item>
                <Typography variant="h4" component="h2" className={classes.weekEnding}>
                    {formatPeriod(weekEnding)}
                </Typography>
            </Grid>
            <Grid item>
                <Typography variant="body2" className={classes.bookingName}>
                    {timesheet.booking.name}
                </Typography>
            </Grid>
        </Grid>
    );

    const renderAdminHeader = () => (
        <Grid container direction="column" spacing={2}>
            <Grid item>
                <Button
                    variant="text"
                    sx={{ color: '#0077C8 !important' }}
                    startIcon={<ChevronLeft />}
                    onClick={() => {
                        if (isDirty || cleared) {
                            setCancelModalOpen(true);
                        } else {
                            history.push('/timesheets');
                        }
                    }}
                >
                    <Typography variant="overline" className={classes.overline1}>
                        All Timesheets
                    </Typography>
                </Button>
            </Grid>
            <Grid item>
                <Grid container direction="column">
                    <Grid item className={classes.clinicianNameHeader}>
                        <Typography variant="h4" component="h2" className={classes.header}>
                            Timesheet for {timesheet?.clinicianName || ''}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="h5" className={`${classes.weekEnding} admin`}>
                            {formatPeriod(weekEnding)}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="caption" className={classes.bookingName}>
                                {timesheet?.booking?.name || ''}
                            </Typography>
                            {timesheet?.isPaperTimesheet && <PaperTimesheetBadge />}
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );

    const renderTimesheetRejectionReasons = () => {
        const rejectedTimesheetReviews = timesheet?.timesheetReviews?.filter(
            (timesheetReview) => timesheetReview.status === TimesheetStatusEnumApi.Rejected
        );

        return (
            <>
                {rejectedTimesheetReviews.map((rejectedTimesheet, i) => {
                    const rejectedComment = rejectedTimesheet?.rejectionReason;
                    const reviewer = timesheet?.booking?.locations?.find(
                        (location) => rejectedTimesheet?.locationId === location.id
                    )?.displayName;
                    return (
                        <Alert
                            severity="error"
                            className={
                                i === rejectedTimesheetReviews.length - 1
                                    ? classes.lastRejectionReasonAlert
                                    : classes.rejectReasonAlert
                            }
                        >
                            <Grid container alignItems="center">
                                {reviewer?.length && reviewer?.length > 0
                                    ? `${t('submitTimesheet:HEADERS.TIMESHEET_REJECTED_BY')} ${
                                          reviewer || ''
                                      }. ${t('submitTimesheet:HEADERS.TIMESHEET_REJECTED')}`
                                    : `${t('submitTimesheet:HEADERS.TIMESHEET_WAS_REJECTED')} ${
                                          rejectedComment?.length && rejectedComment?.length > 0
                                              ? t('submitTimesheet:HEADERS.CHECK_FACILITY_COMMENT')
                                              : ''
                                      }`}
                            </Grid>
                            {rejectedComment?.length > 0 && (
                                <ul className={classes.errorListItem}>
                                    <li>
                                        <Grid container alignItems="center">
                                            <Typography
                                                variant="body2"
                                                classes={{ root: classes.errorText }}
                                            >
                                                Comment from the facility: &quot;
                                                {rejectedTimesheet?.rejectionReason || ''}&quot;
                                            </Typography>
                                        </Grid>
                                    </li>
                                </ul>
                            )}
                        </Alert>
                    );
                })}
            </>
        );
    };

    const handleCommentWarningAlertModalNo = () => {
        if (commentWarningAlertModalOpen) {
            validateSubmitAfterEmptyCheck(false);
        }

        setCommentWarningAlertModalOpen(false);
    };

    const handleHolidayPromptYes = () => {
        setOpenHolidayPrompt(false);
        setHasSelectedYesOnHolidayPrompt(true);

        timesheetInsert(
            holidayPromptProperties.index,
            {
                id: generateNextId(),
                transactionDate: holidayPromptProperties.transactionDate,
                locationId: holidayPromptProperties.locationId,
                rateTypeId: holidayPromptProperties.rateTypeId,
                relatedEntryId: '',
                units: '',
                startTime: '',
                endTime: '',
                comment: '',
                isAddedEntry: true,
            },
            true
        );

        setOpenHolidayPrompt(false);
        methods.trigger();
        setDoRerunHolidayPrompt(true);
    };

    const handleHolidayPromptNo = async () => {
        setOpenHolidayPrompt(false);

        const moreHolidayShifts = await detectHolidayShift(methods.getValues());

        if (!hasSelectedYesOnHolidayPrompt && !moreHolidayShifts) {
            validateSubmitAfterEmptyCheck(false);
        }
    };

    const renderHolidayPrompt = () => (
        <Dialog
            open={openHolidayPrompt}
            onClose={() => setOpenHolidayPrompt(false)}
            aria-labelledby="holiday-modal-title"
            aria-describedby="holiday-modal-description"
            classes={{ paper: classes.dialogPaperRoot }}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle classes={{ root: classes.dialogTitleRoot }} id="holiday-modal-title">
                Holiday Shift Detected
            </DialogTitle>
            <DialogContent
                id="holiday-modal-description"
                classes={{ root: classes.dialogContentRoot }}
            >
                {holidayPromptProperties?.date} is marked as a Holiday{' '}
                {holidayPromptProperties?.name === '' ? '' : `(${holidayPromptProperties?.name})`}.
                Do you want to enter a
                {holidayPromptProperties?.rateTypeId === '' ? ' ' : ' holiday '}shift?
            </DialogContent>
            <DialogActions classes={{ root: classes.dialogActionsRoot }}>
                <Button
                    onClick={handleHolidayPromptNo}
                    color="primary"
                    className={classes.underlinedButton}
                >
                    No
                </Button>
                <Button variant="contained" color="primary" onClick={handleHolidayPromptYes}>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );

    const handleEmptyTimesheetModalNo = () => {
        setEmptyTimesheetModalOpen(false);
        settingDidNotWork.current = false; // just in case it was set somehow
    };

    const handleEmptyTimesheetModalYes = () => {
        timesheet.status = TimesheetStatusEnumApi.DidNotWork;
        settingDidNotWork.current = true;
        setEmptyTimesheetModalOpen(false);
        validateSubmitAfterEmptyCheck(true);
    };

    const renderEmptyTimesheetDialog = () => (
        <Dialog
            open={emptyTimesheetModalOpen}
            onClose={() => setEmptyTimesheetModalOpen(false)}
            aria-labelledby="holiday-modal-title"
            aria-describedby="holiday-modal-description"
            classes={{ paper: classes.dialogPaperRoot }}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle classes={{ root: classes.dialogTitleRoot }} id="holiday-modal-title">
                Empty Timesheet
            </DialogTitle>
            <DialogContent
                id="holiday-modal-description"
                classes={{ root: classes.dialogContentRoot }}
            >
                There is no data in the timesheet you are submitting. If this was done in error then
                select <b>Cancel</b> to return to the timesheet and enter your shift data for the
                week. If this is accurate and you did not work any shifts this week, then select{' '}
                <b>Did Not Work</b> and the status will be updated for this record.
            </DialogContent>
            <DialogActions classes={{ root: classes.dialogActionsRoot }}>
                <Button
                    onClick={handleEmptyTimesheetModalNo}
                    color="primary"
                    className={classes.underlinedButton}
                >
                    Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={handleEmptyTimesheetModalYes}>
                    Did Not Work
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderCancelDialog = () => (
        <Dialog
            open={cancelModalOpen}
            onClose={() => setCancelModalOpen(false)}
            aria-labelledby="cancel-modal-title"
            aria-describedby="cancel-modal-description"
            classes={{ paper: classes.dialogPaperRoot }}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle classes={{ root: classes.dialogTitleRoot }} id="cancel-modal-title">
                Unsaved changes
            </DialogTitle>
            <DialogContent
                id="cancel-modal-description"
                classes={{ root: classes.dialogContentRoot }}
            >
                Your changes have not been saved. Are you sure you want to leave this page with
                unsaved changes?
            </DialogContent>
            <DialogActions classes={{ root: classes.dialogActionsRoot }}>
                <Button
                    component={RouterLink}
                    to={{ pathname: '/timesheets' }}
                    color="primary"
                    className={classes.underlinedButton}
                >
                    Discard changes
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setCancelModalOpen(false)}
                >
                    Stay
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderTimesheetFormHeader = () => (
        <Grid className={classes.headerContainer} container alignItems="center">
            <Grid className={classes.headerCell} item xs={1} md={2} lg={1}>
                <span className={classes.paragraph3}>Date</span>
            </Grid>
            <Grid className={classes.headerCell} item xs={3} md={2} lg={3}>
                <Grid container direction="row" alignItems="center">
                    <div className={classes.paragraph3}>Work Location</div>
                    <ToolTipComponent
                        disableFocusListener
                        enterTouchDelay={150}
                        interactive
                        placement="right"
                        title={<span>Location worked at for a given date</span>}
                    >
                        <InfoOutlined classes={{ root: classes.infoIcon }} />
                    </ToolTipComponent>
                </Grid>
            </Grid>
            <Grid className={classes.headerCell} item xs={1} md={2} lg={1}>
                <Grid container direction="row" alignItems="center">
                    <div className={classes.paragraph3}>Shift Type</div>
                    <ToolTipComponent
                        disableFocusListener
                        enterTouchDelay={150}
                        interactive
                        placement="right"
                        title={<span>Type of worked performed (e.g. Regular)</span>}
                    >
                        <InfoOutlined classes={{ root: classes.infoIcon }} />
                    </ToolTipComponent>
                </Grid>
            </Grid>
            <Grid className={classes.headerCell} item xs={1}>
                <Grid container alignItems="center">
                    <span className={classes.paragraph3}>Units</span>
                    <ToolTipComponent
                        disableFocusListener
                        enterTouchDelay={150}
                        interactive
                        placement="right"
                        title={
                            <span>
                                Indicator for specific shift types that do not require start and end
                                times.
                            </span>
                        }
                    >
                        <InfoOutlined classes={{ root: classes.infoIcon }} />
                    </ToolTipComponent>
                </Grid>
            </Grid>
            <Grid className={classes.headerCell} item xs={1}>
                <span className={classes.paragraph3}>Start</span>
            </Grid>
            <Grid className={classes.headerCell} item xs={1}>
                <span className={classes.paragraph3}>End</span>
            </Grid>
            <Grid className={classes.headerCell} item xs={1}>
                <Grid container alignItems="center">
                    <span className={classes.paragraph3}>Hours</span>
                    <ToolTipComponent
                        disableFocusListener
                        enterTouchDelay={150}
                        interactive
                        placement="right"
                        title={
                            <span>
                                The Total hours calculated by the Start and End time of the shift
                                and breaks.
                            </span>
                        }
                    >
                        <InfoOutlined classes={{ root: classes.infoIcon }} />
                    </ToolTipComponent>
                </Grid>
            </Grid>
            <Grid className={classes.headerCell} item xs={4} md={2}>
                <Grid container direction="row" alignItems="center">
                    <div className={classes.paragraph3}>Comments</div>
                    <ToolTipComponent
                        disableFocusListener
                        enterTouchDelay={150}
                        interactive
                        placement="right"
                        title={
                            <span>
                                Comments will be visible by LT and facility staff. Recommendations:
                                <ul>
                                    <li>Do not list billable hours or call</li>
                                    <li>Do not include rates</li>
                                    <li>Do not include mileage</li>
                                    <li>Include explanation as needed</li>
                                    <li>Include logs for time work as needed</li>
                                </ul>
                            </span>
                        }
                    >
                        <InfoOutlined classes={{ root: classes.infoIcon }} />
                    </ToolTipComponent>
                </Grid>
            </Grid>
        </Grid>
    );

    const renderTimesheetsHeader = () => (
        <Grid container>
            {timesheet?.originalRawTimesheetId && (
                <Alert severity="warning" sx={{ mb: 2, width: '100%' }}>
                    You are viewing a newer version of this timesheet. To see the older version{' '}
                    <RouterLink
                        style={{ textDecoration: 'underline', color: COLORS.LT_JOURNEY }}
                        target="_blank"
                        to={TimesheetReviewConfig.getTimeEntryUrl({
                            id: timesheet?.originalRawTimesheetId,
                            clinicianId: timesheet?.clinicianId,
                            weekEnding: timesheet?.weekEnding,
                        })}
                    >
                        click here
                    </RouterLink>
                    .
                </Alert>
            )}
            <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                <Grid item>
                    <Typography variant="h5" component="h5" gutterBottom className={classes.header}>
                        <span>Shifts</span>
                    </Typography>
                </Grid>
                <Grid item>
                    <Box display="flex" justifyContent="flex-end">
                        <Typography
                            variant="h5"
                            component="h5"
                            gutterBottom
                            className={classes.headerGrey}
                        >
                            <span>Total Hours: {totalTimesheetHours}</span>
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container display="flex" justifyContent="flex-end">
                <Grid item>
                    <Box>
                        <Alert severity="info">
                            All comments are visible to both LocumTenens staff and facility
                            supervisors
                        </Alert>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );

    const renderTimesheetFormButtons = () => (
        <Grid container justifyContent="space-between">
            <Grid item xs={isMobile ? 12 : undefined}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={isMobile ? 12 : undefined}>
                        <Button
                            id="timesheet-entry--button--add-row"
                            variant="contained"
                            classes={{ root: classes.containedPrimaryLight }}
                            className={classes.mobileButton}
                            onClick={() => {
                                timesheetAppend({
                                    id: generateNextId(),
                                    transactionDate: '',
                                    locationId: '',
                                    rateTypeId: '',
                                    relatedEntryId: '',
                                    units: '',
                                    startTime: '',
                                    endTime: '',
                                    comment: '',
                                    isAddedEntry: false, // This is set to false atm to not interfere w/ holiday transition effect
                                });
                            }}
                        >
                            Add Shift
                        </Button>
                    </Grid>
                    {mileageEntries.length === 0 && (
                        <Grid item xs={isMobile ? 12 : undefined}>
                            <Button
                                variant="contained"
                                classes={{ root: classes.containedPrimaryLight }}
                                className={classes.mobileButton}
                                onClick={() => {
                                    mileageAppend({
                                        id: 0,
                                        transactionDate: '',
                                        locationId: '',
                                        miles: '',
                                        comment: '',
                                    });
                                }}
                            >
                                Add Mileage
                            </Button>
                        </Grid>
                    )}
                    <Grid item xs={isMobile ? 12 : undefined}>
                        <Button
                            variant="contained"
                            className={classes.mobileButton}
                            sx={{
                                '&.MuiButtonBase-root.MuiButton-root': {
                                    color: '#5F6A7E',
                                    backgroundColor: '#e0e0e0',
                                    '&:hover': {
                                        backgroundColor: '#d5d5d5',
                                    },
                                },
                            }}
                            disabled={timesheetEntries.length === 0}
                            onClick={() => setClearDialogOpen(true)}
                        >
                            Clear
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            {isAdminApp && historyEnabled && mileageEntries.length === 0 && (
                <Grid item>
                    <TimesheetHistory />
                </Grid>
            )}
        </Grid>
    );

    const isLastCallBackEntry = (index) => {
        if (!timesheetEntries || !timesheetEntries[index].relatedEntryId) return false;

        const lastTimesheetEntryIndex = timesheetEntries.findLastIndex(
            (x) => x.relatedEntryId === timesheetEntries[index].relatedEntryId
        );
        return lastTimesheetEntryIndex === index;
    };

    const renderTimesheetEntries = () => (
        <>
            {renderTimesheetsHeader()}
            <Hidden only={['xs', 'sm']}>{renderTimesheetFormHeader()}</Hidden>
            <Grid
                container
                direction="column"
                spacing={isMobile ? 3 : 1}
                className={classes.entriesContainer}
            >
                {timesheetEntries.map((timesheetEntry, index) => (
                    <TimesheetEntry
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${timesheetEntry.timesheetEntryId}-${index}`}
                        index={index}
                        dateLookup={dateLookup}
                        timesheet={timesheet}
                        timesheetEntry={timesheetEntry}
                        onRemove={handleRemove}
                        isPaidApproved={isPaidApproved}
                        timesheetInsert={timesheetInsert}
                        triggerCallRowLockCheck={false}
                        setTotalTimesheetHours={setTotalTimesheetHours}
                        isLastCallBackEntry={isLastCallBackEntry(index)}
                        isMobile={isMobile}
                        isShowWarning={isShowWarning}
                        // eslint-disable-next-line react/jsx-no-bind
                        generateNextId={generateNextId}
                        forceEditMode={forceEditMode && timesheet.isLatestTimesheetVersion}
                    />
                ))}
            </Grid>
            {!isReadOnly && !adminAuth?.isLTAssociateUser && renderTimesheetFormButtons()}
        </>
    );

    const renderMileageFormHeader = () => (
        <Grid className={classes.headerContainer} container>
            <Grid className={classes.headerCell} item xs={1} md={2} lg={2}>
                <span className={classes.paragraph3}>Date</span>
            </Grid>
            <Grid className={classes.headerCell} item xs={6} md={3}>
                <Grid container direction="row" alignItems="center">
                    <div className={classes.paragraph3}>Work Location</div>
                    <ToolTipComponent
                        disableFocusListener
                        enterTouchDelay={150}
                        interactive
                        placement="right"
                        title={<span>Work location for associated mileage on a given date</span>}
                    >
                        <InfoOutlined classes={{ root: classes.infoIcon }} />
                    </ToolTipComponent>
                </Grid>
            </Grid>
            <Grid className={classes.headerCell} item xs={1}>
                <Grid container direction="row" alignItems="center">
                    <div className={classes.paragraph3}>Mileage</div>
                    <ToolTipComponent
                        disableFocusListener
                        enterTouchDelay={150}
                        interactive
                        placement="right"
                        title={
                            <span>
                                Total number of miles associated to a work location within a week
                                ending period
                            </span>
                        }
                    >
                        <InfoOutlined classes={{ root: classes.infoIcon }} />
                    </ToolTipComponent>
                </Grid>
            </Grid>
            <Grid className={classes.headerCell} item xs={6} md={5} lg={6}>
                <Grid container direction="row" alignItems="center">
                    <div className={classes.paragraph3}>Comments</div>
                    <ToolTipComponent
                        disableFocusListener
                        enterTouchDelay={150}
                        interactive
                        placement="right"
                        title={
                            <span>
                                Comments will be visible by LT and facility staff. Recommendations:
                                <ul>
                                    <li>Do not list billable hours or call</li>
                                    <li>Do not include rates</li>
                                    <li>Do not include mileage</li>
                                    <li>Include explanation as needed</li>
                                    <li>Include logs for time work as needed</li>
                                </ul>
                            </span>
                        }
                    >
                        <InfoOutlined classes={{ root: classes.infoIcon }} />
                    </ToolTipComponent>
                </Grid>
            </Grid>
        </Grid>
    );

    const renderMileageHeader = () => (
        <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            className={classes.headerBar}
        >
            <Grid item>
                <Typography variant="h6" component="h3" className={classes.header}>
                    <span>Mileage</span>
                </Typography>
            </Grid>
        </Grid>
    );

    const renderMileageFormButtons = () => (
        <Grid container direction="row" justifyContent="space-between">
            <Grid item xs={12} sm={3} md={2}>
                <Button
                    id="mileage-entry--button--add-row"
                    variant="contained"
                    className={classes.mileageAddButton}
                    classes={{ root: classes.containedPrimaryLight }}
                    onClick={() =>
                        mileageAppend({
                            id: 0,
                            transactionDate: '',
                            locationId: '',
                            miles: '',
                            comment: '',
                        })
                    }
                >
                    {isMobile ? 'Add Mileage' : 'Add Row'}
                </Button>
            </Grid>
            {isAdminApp && historyEnabled && (
                <Grid item>
                    <TimesheetHistory />
                </Grid>
            )}
        </Grid>
    );

    const renderMileageEntries = () => (
        <>
            {renderMileageHeader()}
            {!isMileageExpected && (
                <Alert severity="warning">
                    Your assignment is not expecting mileage. Are you sure you want to proceed?
                    Please connect with your recruiter with questions.
                </Alert>
            )}
            <Hidden only={['xs', 'sm']}>{renderMileageFormHeader()}</Hidden>
            <Grid
                container
                direction="column"
                spacing={isMobile ? 3 : 1}
                className={classes.entriesContainer}
            >
                {mileageEntries.map((mileageEntry, index) => (
                    <Grid item key={mileageEntry.mileageEntryId} xs={12}>
                        <MileageEntry
                            index={index}
                            dateLookup={dateLookup}
                            timesheet={timesheet}
                            mileageEntry={mileageEntry}
                            onRemove={handleRemove}
                            isPaidApproved={isPaidApproved}
                            isMobile={isMobile}
                            isShowWarning={isShowWarning}
                            forceEditMode={forceEditMode && timesheet.isLatestTimesheetVersion}
                        />
                    </Grid>
                ))}
            </Grid>
            {!isReadOnly && !adminAuth?.isLTAssociateUser && renderMileageFormButtons()}
        </>
    );

    const renderErrorBanner = () => (
        <Grid item>
            {isSave ? (
                <Alert severity="error">
                    Please fill out all missing or incorrect cells to save your timesheet
                </Alert>
            ) : (
                <Alert severity="error">
                    Please fill out all missing or incorrect cells to submit your timesheet
                </Alert>
            )}
        </Grid>
    );

    const renderPageGrid = () => (
        <Container maxWidth="xl" className={classes.ContainerRoot}>
            <FormProvider {...methods}>
                <Grid container direction="column" spacing={4}>
                    <Grid item>{isAdminApp ? renderAdminHeader() : renderClinicianHeader()}</Grid>
                    {formHasRejectedTimesheet && (
                        <Grid item>{renderTimesheetRejectionReasons()}</Grid>
                    )}
                    <Grid item xs={12}>
                        <form ref={formRef} tabIndex="0" className={classes.form}>
                            <Paper elevation={3} className={classes.PaperRoot}>
                                <div id="timesheet-entries" className={classes.entrySection}>
                                    {renderTimesheetEntries()}
                                </div>

                                {mileageEntries.length > 0 && (
                                    <div id="mileage-entries" className={classes.entrySection}>
                                        {renderMileageEntries()}
                                    </div>
                                )}

                                {isAdminApp &&
                                    ltoeWebTimesheetEnablePaperTimesheetUpload &&
                                    timesheet?.id &&
                                    timesheet?.isPaperTimesheet && (
                                        <Box
                                            sx={{
                                                p: 3,
                                                border: `1px solid ${COLORS.LT_MIDNIGHT10}`,
                                                borderRadius: '8px',
                                            }}
                                        >
                                            <TimesheetAttachments
                                                isReadOnly={
                                                    !(
                                                        adminAuth?.isTimesheetAdminUser ||
                                                        adminAuth?.isTimesheetSystemAdminUser
                                                    )
                                                }
                                                rawTimesheetId={timesheet.id}
                                                locations={timesheet?.booking?.locations || []}
                                            />
                                        </Box>
                                    )}
                            </Paper>
                        </form>
                    </Grid>

                    {Object.keys(methods.formState.errors).length > 0
                        ? renderErrorBanner()
                        : undefined}
                    <Grid item>
                        <Grid container justifyContent="flex-end" spacing={2}>
                            {(isReadOnly && isPaidApproved) || adminAuth?.isLTAssociateUser
                                ? null
                                : renderEditButtons()}
                        </Grid>
                    </Grid>
                </Grid>
            </FormProvider>
        </Container>
    );

    const renderRecallWarningDialog = () => (
        <Dialog
            open={recallWarningDialogOpen}
            onClose={() => {
                setRecallWarningDialogOpen(false);
            }}
            aria-labelledby="recall-warning-dialog-title"
            aria-describedby="recall-warning-dialog-description"
            fullWidth
            maxWidth="xs"
            classes={{ paper: classes.dialogPaperRoot }}
        >
            <DialogContent classes={{ root: classes.dialogContentRoot }}>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    className={classes.dialogGrid}
                >
                    <Grid item>
                        <Grid container alignContent="center" justifyContent="center">
                            <PriorityHigh fontSize="large" className={classes.dialogWarningIcon} />
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Typography variant="h5" align="center">
                            Recalling a timesheet stops the approval process and will require the
                            recalled timesheets to be re-submitted.
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions
                classes={{ root: classes.dialogActionsRoot }}
                style={{ justifyContent: 'center' }}
            >
                <Button variant="contained" onClick={() => setRecallWarningDialogOpen(false)}>
                    Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={handleRecall}>
                    Recall
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderRemoveDialog = () => (
        <Dialog
            open={!!removeDialogOpen}
            onClose={() => setRemoveDialogOpen(false)}
            aria-labelledby="remove-dialog-title"
            aria-describedby="remove-dialog-description"
            fullWidth
            maxWidth="xs"
            classes={{ paper: classes.dialogPaperRoot }}
        >
            <DialogTitle id="remove-dialog-title" classes={{ root: classes.dialogTitleRoot }}>
                Are you sure?
            </DialogTitle>
            <DialogContent classes={{ root: classes.dialogContentRoot }}>
                Removing this item cannot be undone. Are you sure you would like to remove this?
            </DialogContent>
            <DialogActions classes={{ root: classes.dialogActionsRoot }}>
                <Button
                    color="primary"
                    className={classes.underlinedButton}
                    onClick={() => setRemoveDialogOpen(false)}
                >
                    No, go back
                </Button>
                <Button
                    color="primary"
                    className={classes.cancelButton}
                    variant="contained"
                    onClick={() => {
                        // Redo validations when removing rows
                        const entryType = removeDialogOpen.isMileageEntry
                            ? 'mileageEntries'
                            : 'timesheetEntries';
                        const { index } = removeDialogOpen;

                        if (entryType === 'mileageEntries') {
                            methods.clearErrors(`mileageEntries[${index}]`);
                        } else {
                            for (let i = 0; i < timesheetEntries.length; i++) {
                                methods.clearErrors(`timesheetEntries[${i}]`);
                            }
                        }

                        if (removeDialogOpen.isMileageEntry) {
                            mileageRemove(removeDialogOpen.index);
                        } else {
                            const entryToRemove =
                                methods.getValues().timesheetEntries[removeDialogOpen.index];
                            const data = methods.getValues();

                            const remainingEntries = data.timesheetEntries.filter(
                                (entry) =>
                                    entry.relatedEntryId !== entryToRemove.id &&
                                    entry.id !== entryToRemove.id
                            );

                            data.timesheetEntries = remainingEntries;

                            methods.setValue('timesheetEntries', remainingEntries);

                            revalidateErrors(data);

                            setHolidayPromptCheckedDates(
                                holidayPromptCheckedDates.filter(
                                    (checkedDate) => checkedDate !== entryToRemove.transactionDate
                                )
                            );
                        }

                        setRemoveDialogOpen(false);
                    }}
                    startIcon={<DeleteOutline fontSize="small" />}
                >
                    Remove
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderClearDialog = () => (
        <Dialog
            open={clearDialogOpen}
            onClose={() => setClearDialogOpen(false)}
            aria-labelledby="clear-dialog-title"
            aria-describedby="clear-dialog-description"
            fullWidth
            maxWidth="xs"
            classes={{ paper: classes.dialogPaperRoot }}
        >
            <DialogTitle id="clear-dialog-title" classes={{ root: classes.dialogTitleRoot }}>
                Are you sure?
            </DialogTitle>
            <DialogContent classes={{ root: classes.dialogContentRoot }}>
                Clearing all your data cannot be undone. Are you sure you would like to clear all
                data?
            </DialogContent>
            <DialogActions classes={{ root: classes.dialogActionsRoot }}>
                <Button
                    color="primary"
                    className={classes.underlinedButton}
                    onClick={() => setClearDialogOpen(false)}
                >
                    No, go back
                </Button>
                <Button
                    color="primary"
                    className={classes.cancelButton}
                    variant="contained"
                    onClick={handleClear}
                >
                    Clear
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderErrorAlert = () => (
        <Snackbar
            open={Boolean(error)}
            autoHideDuration={6000}
            onClose={handleAlertClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert onClose={handleAlertClose} severity="error">
                {error}
            </Alert>
        </Snackbar>
    );

    const renderCommentWarningAlert = (aCommentWordList) => (
        <Dialog
            open={commentWarningAlertModalOpen}
            onClose={() => setCommentWarningAlertModalOpen(false)}
            aria-labelledby="commentwarning-modal-title"
            aria-describedby="commentwarning-modal-description"
            classes={{ paper: classes.dialogPaperRoot }}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle
                classes={{ root: classes.dialogTitleRoot }}
                id="commentwarning-modal-title"
            >
                Comment Warning Detected
            </DialogTitle>
            <DialogContent
                id="commentwarning-modal-description"
                classes={{ root: classes.dialogContentRoot }}
            >
                We detected you may have entered {aCommentWordList} information in a comment.
                <br />
                <br /> To help reduce potential delays in timesheet processing, please enter the
                information directly in the timesheet.
                <br />
                <br /> Review the Help information for additional information.
                <br />
                <br />
            </DialogContent>
            <DialogActions
                classes={{ root: classes.dialogActionsRoot }}
                style={{ justifyContent: 'center' }}
            >
                <Button
                    color="primary"
                    className={classes.underlinedButton}
                    onClick={() => setCommentWarningAlertModalOpen(false)}
                >
                    Go back
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCommentWarningAlertModalNo}
                >
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderRecallErrorDialog = () => {
        const errorDialogProps = {
            name: 'recall-error',
            message: `This timesheet has been recently ${recallErrorType} and is not available
								to be recalled. Please reach out to your recruiter with any
								questions.`,
            onClose: () => {
                setRecallErrorDialogOpen(false);
                setIsLoaded(false);
            },
            onExited: () => {
                history.go(0);
            },
            open: recallErrorDialogOpen,
        };
        return <StatusErrorDialog {...errorDialogProps} />;
    };

    const renderLoadingStatus = () => {
        if (errorLoadingTimesheet) {
            return <h1>{errorLoadingTimesheet}</h1>;
        }
        if (isLoaded) {
            return <>{renderPageGrid()}</>;
        }
        return <CircularProgress classes={{ root: classes.progressRoot }} color="primary" />;
    };

    return (
        <div className={classes.root}>
            {renderLoadingStatus()}
            {renderRecallWarningDialog()}
            {renderClearDialog()}
            {renderRemoveDialog()}
            {renderHolidayPrompt()}
            {renderEmptyTimesheetDialog()}
            {renderCancelDialog()}
            {renderRecallErrorDialog()}
            {renderErrorAlert()}
            {renderCommentWarningAlert(new Intl.ListFormat().format(commentWordList.current))}
        </div>
    );
}

Timesheet.propTypes = {
    t: PropTypes.func.isRequired,
    UserContext: PropTypes.shape({
        externalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    setRefreshNotifications: PropTypes.func,
    timesheet: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        bookingId: PropTypes.number,
        clinicianId: PropTypes.number,
        weekEnding: PropTypes.string,
        status: PropTypes.string,
        comment: PropTypes.string,
        mileageEntries: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                transactionDate: PropTypes.string,
                locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                miles: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                comment: PropTypes.string,
            })
        ),
        timesheetEntries: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                transactionDate: PropTypes.string,
                locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                rateTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                relatedEntryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                startTime: PropTypes.string,
                endTime: PropTypes.string,
                units: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                comment: PropTypes.string,
                timesheetBreaks: PropTypes.arrayOf(
                    PropTypes.shape({
                        startTime: PropTypes.string,
                        endTime: PropTypes.string,
                    })
                ),
            })
        ),
        timesheetReviews: PropTypes.arrayOf(
            PropTypes.shape({
                status: PropTypes.string,
                rejectionReason: PropTypes.string,
                locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            })
        ),
        booking: PropTypes.shape({
            name: PropTypes.string,
            startDate: PropTypes.string,
            endDate: PropTypes.string,
            locations: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                    displayName: PropTypes.string,
                    timeZone: PropTypes.string,
                })
            ),
            availableRates: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                    displayName: PropTypes.string,
                    category: PropTypes.string,
                    associatedRateType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                })
            ),
            mileageExpected: PropTypes.bool,
        }),
        clinicianName: PropTypes.string,
    }),
};

Timesheet.defaultProps = {
    timesheet: null,
    setRefreshNotifications: () => {},
    UserContext: null,
};

export default WithContexts(withRouter(withTranslation()(Timesheet)));
